var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 49,
    viewBox: "0 0 62 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1427 15.0108C32.1427 13.8107 33.1156 12.8378 34.3158 12.8378L46.6085 12.8378C47.8087 12.8378 48.7816 13.8107 48.7816 15.0108L48.7816 27.3036C48.7816 28.5038 47.8087 29.4767 46.6085 29.4767C45.4084 29.4767 44.4355 28.5038 44.4355 27.3036L44.4355 20.2571L32.7792 31.9134C31.9305 32.762 30.5546 32.762 29.706 31.9134C28.8573 31.0648 28.8573 29.6888 29.706 28.8402L41.3623 17.1839L34.3158 17.1839C33.1156 17.1839 32.1427 16.211 32.1427 15.0108Z",
    fill: "#3AB44A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9161 18.6222C15.9161 17.422 16.889 16.4491 18.0892 16.4491L30.382 16.4491C31.5821 16.4491 32.5551 17.422 32.5551 18.6222L32.5551 30.9149C32.5551 32.1151 31.5821 33.088 30.382 33.088C29.1818 33.088 28.2089 32.1151 28.2089 30.9149L28.2089 23.8684L16.5526 35.5247C15.704 36.3734 14.3281 36.3734 13.4794 35.5247C12.6308 34.6761 12.6308 33.3002 13.4794 32.4515L25.1357 20.7952L18.0892 20.7952C16.889 20.7952 15.9161 19.8223 15.9161 18.6222Z",
    fill: "#3AB44A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.46224cbe5b84e020e8e6f88ca6f369f8.svg";
export { ForwardRef as ReactComponent };